module.exports = __webpack_public_path__ + "img/headerImage.995d49d6.jpg";